import React, { useEffect, useState } from "react";
import classes from "./ImageSlider.module.css";
import { SliderData } from "./SliderData";
import prev from "../../../images/svgs/left.svg";
import next from "../../../images/svgs/right.svg";

import gsap from "gsap";

const ImageSlider = () => {
  const [current, setCurrent] = useState(0);
  const length = SliderData.length;

  useEffect(() => {
    const id = setInterval(() => {
      console.log(current)
      console.log(current === length - 1 ? 0 : current + 1)
      setCurrent(current => current === length - 1 ? 0 : current + 1)
    }, 3000);

    return () => {
      clearInterval(id);
    };
  }, []);
  useEffect(() => {
    const active = document.getElementsByClassName(classes.active)[0];
    console.log(active);
    gsap.from(active, {
      duration: 0.5,
      opacity: 0,
    });
  }, [current]);

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(SliderData) || SliderData.length <= 0) {
    return null;
  }

  return (
    <section className={classes.container}>
      <img src={prev} className={classes.left} onClick={prevSlide} />
      {SliderData.map((slide, index) => {
        return (
          <div
            className={
              index === current
                ? classes.slide + " " + classes.active
                : classes.slide
            }
            key={index}
          >
            {index === current && (
              <img
                src={slide.image}
                alt="travel image"
                className={classes.image}
              />
            )}
          </div>
        );
      })}
      <img src={next} className={classes.right} onClick={nextSlide} />
    </section>
  );
};

export default ImageSlider;
